export interface ErrorData {
  status: number
  errors: ErrorModel[]
}

export interface ErrorModel {
  message: string
  code: string | null
}

export interface MassageModel {
  message: string[]
  toastType: ToastType
  isOpen: boolean
}

export enum ToastType {
  Success,
  Warning,
  Error,
}
